import React from 'react';

export default function HomePage() {
  return (
    <div>
      <iframe 
        src="/home.html" 
        style={{
          border: 'none', 
          width: '100%', 
          height: '100vh'
        }} 
        title="Client Intel Homepage"
      />
    </div>
  );
}